import { ProductAcquisitionCostRightMenuStructure } from "../store";
import { PRODUCT_ACQUISITION_COST_RIGHT_MENU } from '../actions-constants/productAcquisitionCostRightMenu.constants'
const initialProductAcquisitionCostRightMenuStructure: ProductAcquisitionCostRightMenuStructure = new ProductAcquisitionCostRightMenuStructure



export function productAcquisitionCostRightMenuReducer(productAcquisitionCostRightMenu: ProductAcquisitionCostRightMenuStructure = initialProductAcquisitionCostRightMenuStructure, action): ProductAcquisitionCostRightMenuStructure {

  switch (action.type) {


    case PRODUCT_ACQUISITION_COST_RIGHT_MENU.SET_INITIAL_SITUATION:
      return {
        ...productAcquisitionCostRightMenu,
        situacao: action.situacao
      }

    case PRODUCT_ACQUISITION_COST_RIGHT_MENU.SET_INITIAL_STATE_MENU:
      return {
        ...productAcquisitionCostRightMenu,
        stateMenu: action.stateMenu
      }

    case PRODUCT_ACQUISITION_COST_RIGHT_MENU.SET_INITIAL_ACQUISITION_COST:
      return {
        ...productAcquisitionCostRightMenu,
        custoPadrao: action.custoPadrao
      }

    case PRODUCT_ACQUISITION_COST_RIGHT_MENU.SET_FILTERS:
      return {
        ...productAcquisitionCostRightMenu,
        filters: action.filters
      }

    default:
      return productAcquisitionCostRightMenu
  }
}